import Vue from 'vue'
import * as api from '../api/elixioConnectApi'

const state = Vue.observable({
  services: [],
  loading: false,
})

export function useElixioConnectStore() {
  return {
    // State (reactive)
    get services() { return state.services },
    get loading() { return state.loading },

    // --- Services ---

    async fetchAllServices(organizationId) {
      state.loading = true
      try {
        var { data } = await api.getAllServices(organizationId)
        state.services = data.data ?? data
        return state.services
      } finally {
        state.loading = false
      }
    },

    async refreshService(organizationId, serviceId) {
      var { data } = await api.refreshService(organizationId, serviceId)
      return data
    },

    async subscribe(organizationId, payload) {
      var { data } = await api.subscribe(organizationId, payload)
      return data
    },

    async toggleServiceActivation(organizationId, payload) {
      var { data } = await api.toggleServiceActivation(organizationId, payload)
      return data
    },

    async updateConfigs(organizationId, payload) {
      var { data } = await api.updateConfigs(organizationId, payload)
      return data
    },

    // --- Batch ---

    async syncBatch(organizationId, serviceType, createdAfter) {
      var { data } = await api.syncBatch(organizationId, serviceType, createdAfter)
      return data
    },

    async getBatch(organizationId, batchId) {
      var { data } = await api.getBatch(organizationId, batchId)
      return data
    },

    // --- Shipments ---

    async fetchAllShipments(params) {
      var { data } = await api.getAllShipments(params)
      return data
    },

    async fetchShipments(shippableType, shippableId) {
      var { data } = await api.getShipments(shippableType, shippableId)
      return data
    },

    async fetchShipment(shipmentId, serviceId) {
      var { data } = await api.getShipment(shipmentId, serviceId)
      return data
    },

    async estimateShipment(shippableType, shippableId, payload) {
      var { data } = await api.estimateShipment(shippableType, shippableId, payload)
      return data
    },

    async editEstimation(shipmentId, payload) {
      var { data } = await api.editEstimation(shipmentId, payload)
      return data
    },

    async destroyEstimation(shipmentId) {
      var { data } = await api.destroyEstimation(shipmentId)
      return data
    },

    async createShipment(shipmentId, serviceId) {
      var { data } = await api.createShipment(shipmentId, serviceId)
      return data
    },

    async createPickup(shipmentId, pickupDetails) {
      var { data } = await api.createPickup(shipmentId, pickupDetails)
      return data
    },

    async cancelShipment(shipmentId) {
      var { data } = await api.cancelShipment(shipmentId)
      return data
    },

    async cancelPickup(shipmentId) {
      var { data } = await api.cancelPickup(shipmentId)
      return data
    },

    async printShipmentLabel(shipmentId, labelType) {
      var { data } = await api.printShipmentLabel(shipmentId, labelType)
      return data
    },

    async trackShipment(shipmentId) {
      var { data } = await api.trackShipment(shipmentId)
      return data
    },
  }
}
